import {
  NotificationListResponse,
  MarkAsReadResponse,
  MarkAllAsReadResponse
} from '../../types/notification';

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Fetch notifications for a specific owner
 */
export const fetchNotifications = async (
  netId: string,
  page: number = 1,
  pageSize: number = 20,
  unreadOnly: boolean = false,
  includeCoOwned: boolean = true
): Promise<NotificationListResponse> => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
    unread_only: unreadOnly.toString(),
    include_co_owned: includeCoOwned.toString()
  });

  const response = await fetch(
    `${API_BASE_URL}/api/notifications/owner/${netId}?${params}`,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch notifications: ${response.statusText}`);
  }

  return await response.json();
};

/**
 * Mark a single notification as read
 */
export const markNotificationAsRead = async (
  notificationId: string,
  netId: string
): Promise<MarkAsReadResponse> => {
  const params = new URLSearchParams({
    net_id: netId
  });

  const response = await fetch(
    `${API_BASE_URL}/api/notifications/${notificationId}/read?${params}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to mark notification as read: ${response.statusText}`);
  }

  return await response.json();
};

/**
 * Mark all notifications as read for an owner
 */
export const markAllNotificationsAsRead = async (
  netId: string,
  includeCoOwned: boolean = true
): Promise<MarkAllAsReadResponse> => {
  const params = new URLSearchParams({
    include_co_owned: includeCoOwned.toString()
  });

  const response = await fetch(
    `${API_BASE_URL}/api/notifications/owner/${netId}/read-all?${params}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to mark all notifications as read: ${response.statusText}`);
  }

  return await response.json();
};
